<div class="loading-overlay" 
     *ngIf="isVisible" 
     [class.transparent]="transparent"
     [class.no-backdrop]="!backdrop">
  
  <!-- Backdrop -->
  <div class="loading-backdrop" *ngIf="backdrop && overlay"></div>
  
  <!-- Loading Content -->
  <div class="loading-content" [ngClass]="'loading-' + loadingType">
    
    <!-- Spinner Type -->
    <div *ngIf="loadingType === 'spinner'" class="spinner-container">
      <div class="wb-spinner">
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-logo">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
          </svg>
        </div>
      </div>
      <p class="loading-message">{{ loadingMessage }}</p>
    </div>

    <!-- Dots Type -->
    <div *ngIf="loadingType === 'dots'" class="dots-container">
      <div class="dots-loader">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
      <p class="loading-message">{{ loadingMessage }}</p>
    </div>

    <!-- Pulse Type -->
    <div *ngIf="loadingType === 'pulse'" class="pulse-container">
      <div class="pulse-loader">
        <div class="pulse-circle"></div>
        <div class="pulse-circle"></div>
        <div class="pulse-circle"></div>
      </div>
      <p class="loading-message">{{ loadingMessage }}</p>
    </div>

    <!-- Skeleton Type -->
    <div *ngIf="loadingType === 'skeleton'" class="skeleton-container">
      <div class="skeleton-item">
        <div class="skeleton-avatar"></div>
        <div class="skeleton-content">
          <div class="skeleton-line skeleton-line-title"></div>
          <div class="skeleton-line skeleton-line-subtitle"></div>
          <div class="skeleton-line skeleton-line-text"></div>
        </div>
      </div>
      <div class="skeleton-item">
        <div class="skeleton-avatar"></div>
        <div class="skeleton-content">
          <div class="skeleton-line skeleton-line-title"></div>
          <div class="skeleton-line skeleton-line-subtitle"></div>
        </div>
      </div>
      <p class="loading-message">{{ loadingMessage }}</p>
    </div>

  </div>
</div>